import types from './types';

const setUser = ({ commit }: { commit: any }, payload: any) =>
  commit(`${types.ROOT}${types.SET_USER}`, payload, { root: true });

const setOsaId = ({ commit }: { commit: any }, payload: any) =>
  commit(`${types.ROOT}${types.SET_OSAID}`, payload, { root: true });

const setSupportSelected = ({ commit }: { commit: any }, payload: any) =>
  commit(`${types.ROOT}${types.SET_SUPPORT_SELECTED}`, payload, { root: true });

export default {
  setUser,
  setOsaId,
  setSupportSelected,
};
